/**
 * @internal
 */
export var getListedPrice = function (price) {
    if (!price) {
        return;
    }
    return price.listedPrice
        || price.c_listedPrice
        || price.fromListedPrice;
};
